import { UserDetailsDto } from '@/api/generated';
import { createContext, Dispatch, SetStateAction } from 'react';

export interface UserContextProps {
  isInitialized: boolean;
  setIsInitialized: Dispatch<SetStateAction<boolean>>;
  setUser: Dispatch<SetStateAction<UserDetailsDto | undefined>>;
  user: UserDetailsDto | undefined;
}

export const UserContext = createContext<UserContextProps | undefined>(undefined);
